export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8795.21d77220.jpg";